import React, {useEffect, useRef, useState} from "react";
import { useLocation } from "react-router-dom";
import {
    Box,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox, Stack, Typography, CircularProgress, Collapse, IconButton, FormHelperText,
} from "@mui/material";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from "@mui/icons-material/Check";
import {motion} from "framer-motion";
import BlurredComponent from "../common/BlurredComponent_all";
import {styled} from "@mui/material/styles";
import SearchableSelect from "./SearchableSelect";
import {useWebSocket} from "../net/WebSocketContext";
import BlurredComponent_all from "../common/BlurredComponent_all";

const ExpandMore = styled((props) => {
    const {expand, ...other} = props;
    return <IconButton {...other} />;
})(({theme}) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({expand}) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({expand}) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

//TODO Добавить кратность полей
const UserProfile = () => {
    const { ws, isConnected, profile, refresh, loading, progress } = useWebSocket();
    const [partnerList, setPartnerList] = useState([]);
    const [consistent, setConsistent] = useState(true);
    const [wait, setWait] = useState(false);
    const [edit, setEdit] = useState(false);
    const [save, setSave] = useState(false);
    const [actionSave, setActionSave] = useState(false);
    const on_save = useRef(false);
    const name_ref = useRef("");
    const lock_send = useRef(false);
    const [username, setUsername] = useState("");
    const [selectedEvent, setSelectedEvent] = useState(null);
    const selectedEvent_ref = useRef(null);
    const [selectedDances, setSelectedDances] = useState([]);
    const [danceSelections, setDanceSelections] = useState(null);
    const [danceSelectionsChanged, setDanceSelectionsChanged] = useState(false)
    const [profile_, setProfile_] = useState({});
    const last_profile = useRef(null);
    const [openCollapse, setOpenCollapse] = useState(false)
    const [eventList, setEventList] = useState([])
    const [eventData, setEventData] = useState({})
    const [number, setNumber] = useState([])
    const query = new URLSearchParams(useLocation().search);
    const id = useRef(query.get("id") ?? localStorage.getItem('id'))
    const location = useLocation();


    const nameError = !username || username.trim() === "";

    //console.log("ID", id.current, location)


    useEffect(() => {
        if(refresh){
            //console.log("ON_MESSAGE UserProfile", refresh)
            const body = {
                action: "profile",
                last_event: selectedEvent_ref?.current ?? null,
                event:selectedEvent?.value,
                id : id.current

            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body);
        }
    }, [refresh]);

    useEffect(() => {
        if(selectedEvent || (location?.search !== "" ) ){
            console.log("ON_MESSAGE selectedEvent, location", selectedEvent, location);
            const body = {
                action: "profile",
                last_event: selectedEvent_ref?.current ?? null,
                event:selectedEvent?.value,
                id : id.current
            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body);
        }
    }, [selectedEvent,location]);

    useEffect(() => {
        //console.log("ON_MESSAGE UserProfile", profile)
        if (on_save.current && !save) {
            if (deepEqual(last_profile.current,
                {
                    danceSelections: profile?.profile?.danceSelections,
                    selectedDances: profile?.profile?.selectedDances
                }) && name_ref?.current === profile?.name) {
                setSave(true)
                on_save.current = false
                console.log("PROFILE SAVED")
            } else {
                console.log("PROFILE SAVE ERROR")
            }
        } else {
            if(profile?.name !== ""){
                name_ref.current = profile?.name
                setUsername(profile?.name)
            }
            setDanceSelections(profile?.profile?.danceSelections)
            setSelectedDances(profile?.profile?.selectedDances ?? [])
        }
        if (profile?.name) {
            setUsername(profile.name)
        }
        if (profile?.profile?.number) {
            setNumber(profile.profile?.number)
        }
        if (profile?.users_list) {
            setPartnerList(profile.users_list)
        }
        if (profile?.last_event) {
            if (selectedEvent === null) {
                lock_send.current = true
                setUsername(profile?.name)
                //console.log(profile.events,profile?.last_event?.value,profile.events?.find(f=>f.event.value === profile?.last_event?.value))
                setSelectedEvent(profile.events?.find(f=>f?.event?.value === profile?.last_event?.value)?.event)
            }
        }
        if (profile?.events) {
            setEventData(profile.events.filter(item => item?.event?.value === profile.last_event?.value)[0])
            setEventList(profile.events.map((e) => {
                return e.event
            }))
        }
    }, [profile]);

    // Пишем profile,username в WS
    useEffect(() => {
        if (!ws || !actionSave) {
            console.log("Нет готовности отправлять по ws")
            return;}
        setActionSave(false)
        const sendOnOpen = () => {
            let body = {
                action: "profile",
                event: selectedEvent?.value ?? null,
                name: username ?? null,
                id : id.current
            }
            body.profile = profile_?.danceSelections ? {
                danceSelections: profile_?.danceSelections ?? null,
                    selectedDances: profile_?.selectedDances ?? null
            } : null
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body);
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }, [actionSave]);

    // Пишем в WS selectedEvent
    useEffect(() => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        id.current = query.get("id") ?? localStorage.getItem('id')
        const sendOnOpen = () => {
            setWait(true)
            if(!lock_send.current){
                // Отправляем новое состояние через WebSocket
                let body = {
                    action: "profile",
                    last_event: selectedEvent_ref?.current ?? null,
                    event:selectedEvent?.value,
                    id : id.current
                }
                ws.zsend(JSON.stringify(body))
                console.log("SEND:",body);
            }
            else{
                lock_send.current=false
                setWait(false)
            }
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }, []);

    useEffect(() => {
        if(!selectedEvent){
            if(eventList.length>0){
                setSelectedEvent(eventList.find(e => !e.lock ))
                selectedEvent_ref.current=eventList.find(e => !e.lock )
            }
        }
    }, [eventList]);

    useEffect(() => {
        Object.keys(danceSelections ?? {}).forEach((dance) => {
            Object.keys(danceSelections?.[dance] ?? {}).forEach((name) => {
                const classes = eventData.classList[dance][name];
                if (classes?.length === 1) {
                    handleClassChange(dance, name, classes[0]);
                }
            });
        });
    }, [danceSelectionsChanged]);

    const handleDanceChange = (dance) => {
        setSelectedDances((prev) =>
            prev?.includes(dance) ? prev?.filter((d) => d !== dance) : [...prev, dance]
        );
    };
    const removeEmptyFields = (obj) => {
        for (const key in obj) {
            // Если свойство является объектом, рекурсивно обрабатываем его
            if (obj[key] && typeof obj[key] === 'object') {
                removeEmptyFields(obj[key]);
            }

            // Удаляем поле, если оно пустое (null, undefined, пустая строка, пустой массив или пустой объект)
            if (
                obj[key] === null ||
                obj[key] === undefined ||
                (typeof obj[key] === 'string' && obj[key].trim() === '') ||
                (Array.isArray(obj[key]) && obj[key].length === 0) ||
                (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)
            ) {
                console.log(key,obj)//delete obj[key];
            }
        }
        //return obj;
    }
    const deepEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true; // Если ссылаются на один объект

        if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null)
            return false; // Если это примитивы или один null

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false; // Если разное число ключей

        return keys1.every((key) => deepEqual(obj1[key], obj2[key])); // Рекурсивно сравниваем значения
    };
    const handleCategoryChange = (dance, category, isChecked) => {
        setDanceSelectionsChanged(!danceSelectionsChanged);
        setDanceSelections((prev) => {
            const updatedDance = { ...prev?.[dance] };
            if (isChecked) {
                updatedDance[category] = {partner: "", class: "", role: ""};
            } else {
                delete updatedDance[category];
            }
            return { ...prev, [dance]: updatedDance };
        });
    };
    const onSave = () => {
        setActionSave(true)
        on_save.current = true
        setEdit(false)
        setSave(false)
        setOpenCollapse(false)
        console.log("set SAVE")
        setProfile_({
            selectedDances,
            danceSelections
        })
        last_profile.current = {
            selectedDances,
            danceSelections
        }
    }
    const handleClassChange = (dance, category, selectedClass) => {
        if(danceSelections){
            setDanceSelections((prev) => ({
                ...prev,
                [dance]: {
                    ...prev[dance],
                    [category]: { ...prev[dance]?.[category], class: selectedClass },
                },
            }));
        }
    };
    const handlePartnerChange = (dance, category, partner) => {
        setDanceSelections((prev) => ({
            ...prev,
            [dance]: {
                ...prev[dance],
                [category]: { ...prev[dance][category], partner },
            },
        }));
    };
    const handleEventChange = (event) => {
        const selected = eventList.find(e => e.value === event.target.value);
        selectedEvent_ref.current = selected
        setSelectedEvent(selected || null);
        setSelectedDances([])
        setDanceSelections({})

    };
    const handleRoleChange = (dance, category, role) => {
        setDanceSelections((prev) => ({
            ...prev,
            [dance]: {
                ...prev[dance],
                [category]: {...prev[dance][category], role},
            },
        }));
    };
    const handleExpandClick = () => {
        if(!openCollapse){
            setEdit(true)
        }
        setOpenCollapse(!openCollapse);
    };

    // Проверка всех полей на ошибки
    // Считаем ошибки динамически с учётом всех условий
    const errorCount = React.useMemo(() => {
        const ds = danceSelections ?? {};
        const sd = selectedDances ?? [];
        const categoriesMap = eventData?.categoriesList ?? {};
        const classesMap = eventData?.classList ?? {};

        let count = 0;

        // 1) Имя обязательно
        if (nameError)
        {
            count += 1;
            setEdit(true);
        }

        // 2) Динамические поля по выбранным танцам/категориям
        sd.forEach((dance) => {
            const categories = categoriesMap?.[dance] ?? [];
            categories.forEach(({ name, isPair, randomPair }) => {
                const sel = ds?.[dance]?.[name];
                if (!sel) return; // категория не выбрана чекбоксом — пропускаем

                // ROLE: только для парных
                if (isPair && !sel.role) count += 1;

                // PARTNER: только для парных и НЕ randomPair
                if (isPair && !randomPair && !sel.partner) count += 1;

                // CLASS: учитываем автоподстановку, если в списке ровно один класс
                const classList = classesMap?.[dance]?.[name] ?? [];
                const effectiveClass = sel.class || (classList.length === 1 ? classList[0] : "");
                if (!effectiveClass) count += 1;
            });
        });

        return count;
    }, [nameError, danceSelections, selectedDances, eventData]);

    const hasErrors = errorCount > 0;


    return (
        <>
            <BlurredComponent_all isBlurred={(!isConnected || loading)} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"} />
            <Box sx={{
                width: '100%',
                margin: "auto",
                mt: 0,
                p: 1,
                overflow: 'auto',
                height: (window.innerHeight - 100) + 'px'
            }}>

                <TextField
                    disabled={!edit}
                    fullWidth
                    label="Имя и Фамилия для обьявлений:"
                    value={username}
                    onChange={(e) => { setUsername(e.target.value); name_ref.current = e.target.value; }}
                    sx={{ mb: 2 }}
                    error={nameError}
                    helperText={nameError ? "Пожалуйста, укажите имя и фамилию*" : ""}
                />
                <Stack spacing={2}>
                    <Stack direction="row" spacing={2}>
                        <Button
                            disabled={hasErrors || !edit || selectedEvent?.lock}
                            variant="contained" color="primary" onClick={onSave}>
                            Сохранить
                        </Button>
                        <Button disabled={selectedEvent?.lock} variant={edit ? "outlined" : "contained"} color="primary" onClick={() => {
                            setEdit(true)
                            setSave(false)
                            setOpenCollapse(true);
                        }}>
                            Изменить
                        </Button>
                        {save && (
                            <motion.div
                                initial={{opacity: 0, scale: 0}}
                                animate={{opacity: 1, scale: 1}}
                                exit={{opacity: 0, scale: 0}}
                                transition={{duration: 0.9}}
                            >
                                <CheckIcon color="success" fontSize="medium"/>
                            </motion.div>
                        )}
                    </Stack>
                {/* Выбор танцев */}

                <FormControl fullWidth sx={{ml: 2}}>
                    <InputLabel>Соревнования</InputLabel>
                    <Select
                        value={selectedEvent ? selectedEvent.value : ""}
                        onChange={handleEventChange}
                        label="Выберите событие"
                    >
                        {eventList.map((event) => (
                            <MenuItem key={event.value} value={event.value}>
                                {event.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Stack display={ selectedEvent ? '': 'none' } direction="row" spacing={2}>
                    <Typography variant="h6">Регистрация на участие:</Typography>
                    <ExpandMore
                        expand={openCollapse}
                        onClick={handleExpandClick}
                        aria-expanded={openCollapse}
                        aria-label="show more"
                    ><ExpandMoreIcon/>
                    </ExpandMore>
                </Stack>
                </Stack>
                {(   eventData?.dancesList?.length > 0
                    && Object.keys(eventData?.categoriesList).length > 0
                    && Object.keys(eventData?.classList).length > 0 ) ?
                <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                    {!selectedEvent?.lock ?
                    <Stack spacing={2}>
                        <>
                            <Box sx={{mb: 2}}>
                                <InputLabel>Выберите направление</InputLabel>
                                {(eventData?.dancesList ?? []).map((dance) => (
                                    <Box key={dance}>
                                        <Checkbox
                                            disabled={!edit}
                                            //color={confirm[dance] ? "success" : "error"}
                                            checked={selectedDances?.includes(dance)}
                                            onChange={() => handleDanceChange(dance)}
                                        />
                                        {dance}
                                    </Box>
                                ))}
                            </Box>
                            {/* Выбор категорий, партнеров и классов */}
                            {(selectedDances ?? []).map((dance) => (
                                <Box key={dance} sx={{mb: 2, p: 2, border: "1px solid #ddd"}}>
                                    <InputLabel>{dance}</InputLabel>
                                    {(eventData?.categoriesList?.[dance] ?? []).map(({name, isPair, randomPair},index) => (

                                        <Box  key={name} sx={{ml: 2, mb: 1}}>
                                            <Checkbox
                                                disabled={!edit}
                                                //color={ danceSelections[dance]?.[name] ? "success" : "error"}
                                                checked={danceSelections ? !!danceSelections?.[dance]?.[name] : false}
                                                onChange={(e) => handleCategoryChange(dance, name, e.target.checked)}
                                            />
                                            {name}

                                            {danceSelections?.[dance]?.[name] && (
                                                <Stack spacing={2}>
                                                {isPair && (
                                                    <Box sx={{ ml: 0, minWidth: 80 }}>
                                                        <FormControl  error={!danceSelections?.[dance]?.[name]?.role}>
                                                            {!danceSelections?.[dance]?.[name]?.role && (
                                                                <FormHelperText sx={{ml:0}}>Пожалуйста, выберите роль*</FormHelperText>
                                                            )}
                                                            <RadioGroup
                                                                row
                                                                value={danceSelections?.[dance]?.[name]?.role ?? ""}
                                                                onChange={(e) => handleRoleChange(dance, name, e.target.value)}
                                                            >
                                                                <FormControlLabel
                                                                    value="leader"
                                                                    control={<Radio disabled={!edit} />}
                                                                    label="Я - Leader"
                                                                />
                                                                <FormControlLabel
                                                                    value="follower"
                                                                    control={<Radio disabled={!edit} />}
                                                                    label="Я - Follower"
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                )}
                                                    <Stack direction="column" spacing={1}>
                                                        {(isPair && !randomPair ) && (
                                                            <Box sx={{ ml: 2, minWidth: 80 }}>
                                                            <FormControl sx={{ ml: -2 }} error={!danceSelections?.[dance]?.[name]?.partner} fullWidth>
                                                                {!danceSelections?.[dance]?.[name]?.partner && (
                                                                    <FormHelperText>Пожалуйста, выберите партнёра*</FormHelperText>
                                                                )}
                                                                <SearchableSelect
                                                                    error={!danceSelections?.[dance]?.[name]?.partner}
                                                                    partnerList={partnerList}
                                                                    edit={edit}
                                                                    value={danceSelections?.[dance]?.[name]?.partner ?? ""}
                                                                    onChange={(e) => handlePartnerChange(dance, name, e.target.value)}
                                                                />
                                                            </FormControl>
                                                            </Box>
                                                        )}
                                                        <Box sx={{ ml: 2, minWidth: 80 }}>
                                                            {/* Ошибка над всем блоком */}
                                                            {(!danceSelections?.[dance]?.[name]?.class && eventData?.classList?.[dance]?.[name]?.length !== 1) && (
                                                                <Typography variant="caption" color="error" sx={{ display: "block", mb: 0.5 }}>
                                                                    Пожалуйста, выберите класс*
                                                                </Typography>
                                                            )}

                                                            <FormControl fullWidth error={(!danceSelections?.[dance]?.[name]?.class && eventData?.classList?.[dance]?.[name]?.length !== 1)}>
                                                                <InputLabel>Класс</InputLabel>
                                                                <Select
                                                                    sx={{maxWidth:800}}
                                                                    disabled={!edit}
                                                                    value={
                                                                        ((eventData?.classList?.[dance]?.[name]?.length === 1 )
                                                                            ? eventData.classList[dance][name][0]
                                                                            : danceSelections?.[dance]?.[name]?.class) ?? ""
                                                                    }
                                                                    onChange={(e) => handleClassChange(dance, name, e.target.value)}
                                                                >
                                                                    {(eventData?.classList?.[dance]?.[name] ?? []).map((cls) => (
                                                                        <MenuItem key={cls} value={cls}>
                                                                            {cls}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>

                                                    </Stack>
                                                </Stack>
                                            )
                                            }

                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </>
                        <Stack direction="row" spacing={2}>
                            <Button
                                disabled={hasErrors || !edit || selectedEvent?.lock}
                                variant="contained" color="primary" onClick={onSave}>
                                Сохранить
                            </Button>
                            <Button disabled={selectedEvent?.lock} variant={edit ? "outlined" : "contained"} color="primary" onClick={() => {
                                setEdit(true)
                                setSave(false)
                                setOpenCollapse(true);
                            }}>
                                Изменить
                            </Button>
                            {save && (
                                <motion.div
                                    initial={{opacity: 0, scale: 0}}
                                    animate={{opacity: 1, scale: 1}}
                                    exit={{opacity: 0, scale: 0}}
                                    transition={{duration: 0.9}}
                                >
                                    <CheckIcon color="success" fontSize="large"/>
                                </motion.div>
                            )}
                        </Stack>
                    </Stack> :
                        <>
                            <div className="cat-svg-demo__parent">
                                <svg viewBox="0 0 14 13">
                                    <path className="cat" fill="#303030"
                                          d="M12.9 6.9c0 2.5-2.6 4.7-5.7 4.7S1.4 9.4 1.4 6.9c0-1 .3-1.9 1-2.7.6-.7 1.5-1.3 2.5-1.6.7-.2 1.5-.3 2.3-.3 3.1-.1 5.7 2 5.7 4.6z"/>
                                    <path className="ear1" fill="#303030"
                                          d="M11.6,0.8c0.4,1.1,0.3,2.3,0,3.4L9.1,2.8C10.2,1.7,11.1,0.9,11.6,0.8z"/>
                                    <path className="ear" fill="#303030"
                                          d="M2.5,1c0.9,0.4,1.7,1.1,2.4,1.9L2.5,4.4C2,3.2,1.9,2,2.5,1L2.5,1z"/>
                                    <ellipse className="eye" fill="#FFF" cx="9.2" cy="6.6" rx="1.1" ry=".8"/>
                                    <ellipse className="eye" fill="#FFF" cx="4.8" cy="6.6" rx="1.1" ry=".8"/>
                                    <ellipse className="pupils" fill="#303030" cx="4.8" cy="6.8" rx=".2" ry=".5"/>
                                    <ellipse className="pupils" fill="#303030" cx="9.2" cy="6.8" rx=".2" ry=".5"/>
                                    <path className="moustache" stroke="#303030" strokeWidth=".25" strokeMiterlimit="10" d="M13.8 8.1l-1.1-.2m1.2 2l-1.8-.8m1.1 2.5L11 10.1M.3 8.1l1.3-.2M.1 9.8l2-.8M.9 11.5l2.3-1.4"/>
                                </svg>
                            </div>
                            <Typography variant="body1" color={"red"}>Регистрация завершена </Typography>
                            <Typography variant="body2">По всем возникшим вопросам можно обращаться к
                                организаторам.</Typography>
                        </>
                    }
                    {/* Кнопки */}

                </Collapse>
                    : ''}
                {/* Сводная таблица */}
                <Typography sx={{mt: 3}} variant="body1">Твоя регистрация на {selectedEvent?.name} :</Typography>
                <TableContainer component={Paper} sx={{mt: 1}}>
                    <Table style={{display: selectedEvent ? '' : 'none'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Танец</TableCell>
                                <TableCell>Категория</TableCell>
                                <TableCell>Партнер</TableCell>
                                <TableCell>Класс</TableCell>
                                <TableCell>Роль</TableCell>
                                <TableCell>Номер</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(selectedDances ?? []).flatMap((dance) =>
                                Object.entries(danceSelections?.[dance] || {}).map(([category, {
                                    partner,
                                    class: cls,
                                    role
                                }]) => (
                                    <TableRow key={`${dance}-${category}`}>
                                        <TableCell>{dance}</TableCell>
                                        <TableCell>{category}</TableCell>
                                        <TableCell>{partnerList.filter(item => item?._id === partner)?.[0]?.name || "—"}</TableCell>
                                        <TableCell>{cls || "—"}</TableCell>
                                        <TableCell>{role || "—"}</TableCell>
                                        <TableCell>{number || "—"}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    );
};

export default UserProfile;
